import EventBlock from './EventBlock'
import EventCardBlock from './EventCardBlock'

export { EventBlock, EventCardBlock }
